import { api } from '@/lib/api';
import type { AppClient, AppConfig, AppPlatform, PublicAppConfig, UpdateAppConfigInput } from './types';
import { path_for } from './types';

export async function fetch_app_configs(): Promise<AppConfig[]> {
  const res = await api.get<{ items: AppConfig[] }>('/admin/app-configs');
  return res.data.items;
}

export async function update_app_config(
  app: AppClient,
  platform: AppPlatform,
  input: UpdateAppConfigInput,
): Promise<AppConfig> {
  const res = await api.patch<AppConfig>(`/admin/app-configs/${path_for(app, platform)}`, input);
  return res.data;
}

/**
 * Ask the PUBLIC endpoint what a given build would be told — the same call, to the same
 * URL, that a phone makes on its splash screen.
 *
 * Deliberately not a client-side re-implementation of the rule. A mirrored copy is a
 * second source of truth that drifts the moment the backend's logic changes, and this
 * panel exists precisely so an operator can trust what they are about to do to the
 * userbase. The endpoint ignores the Authorization header this client attaches.
 */
export async function preview_public_config(
  app: AppClient,
  platform: AppPlatform,
  build: number,
): Promise<PublicAppConfig> {
  const res = await api.get<PublicAppConfig>('/config', {
    params: { app: app.toLowerCase(), platform: platform.toLowerCase(), build },
    /*
     * A 401 here would say nothing about the admin's session — this route takes no auth
     * at all — so it must not be allowed to sign them out mid-edit.
     */
    no_session_teardown: true,
  });
  return res.data;
}
